import { connect } from "react-redux";
import * as usersActions from "../users/actions";
import * as creditSettlementActions from "../creditSettlement/actions";
import * as loanActions from "./actions";

import moment from "moment";

//TODO this (and the user one as well) connector is just insane xD needs to be splitted...
function mapStateToProps(state) {
  return {
    loans: state.creditSettlement,
    adHocDataPending: state.users.adHocDataPending,
    adHocDataComplete: state.users.adHocDataComplete,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLoans: (id, paidOut, exported, fullyPaid, offset, take) => {
      dispatch(
        creditSettlementActions.get_settlements(
          id,
          paidOut,
          exported,
          fullyPaid,
          offset,
          take,
        ),
      );
    },

    getLoanDetails: (id) => {
      dispatch(creditSettlementActions.get_loan_details(id));
    },

    changeLoanListPage: (page) => {
      dispatch(loanActions.change_loan_list_page(page));
    },

    changeLoanListFilter: (type, key, value, valueKey, prevFilter) => {
      dispatch(
        loanActions.change_loan_list_filter(
          key,
          value,
          type,
          valueKey,
          prevFilter,
        ),
      );
    },

    fullRepayment: (loanId, accountId, date, amount) => {
      date = moment(date).format("YYYY-MM-DD");
      dispatch(loanActions.full_repayment(loanId, accountId, date, amount));
    },

    getFullRepayment: (loanId, date) => {
      date = moment(date).format("YYYY-MM-DD");
      dispatch(loanActions.get_full_repayment(loanId, date));
    },

    removeFees: (data, removalType) => {
      dispatch(loanActions.remove_fees(data, removalType));
    },

    getAdHocDataPendingForId: (creditId) => {
      dispatch(usersActions.get_ad_hoc_pending_data_for_credit_id(creditId));
    },

    getAdHocDataCompleteForId: (creditId) => {
      dispatch(usersActions.get_ad_hoc_complete_data_for_credit_id(creditId));
    },

    updateLoanStatus: (creditId, asOfDate) => {
      asOfDate = moment(asOfDate).format("YYYY-MM-DD");

      dispatch(loanActions.update_loan_status(creditId, asOfDate));
    },

    updateLoans: () => {
      dispatch(creditSettlementActions.update_loans());
    },

    addToDCAProcess: (creditId) => {
      dispatch(creditSettlementActions.add_to_dca_process(creditId));
    },

    closeDCAProcess: (creditId) => {
      dispatch(creditSettlementActions.close_dca_process(creditId));
    },

    addDCAMonthlyRepayment: (
      principalAmount,
      interestAmount,
      feesAmount,
      OCR,
      bankReceiveDate,
      lastPayment,
    ) => {
      dispatch(
        creditSettlementActions.add_dca_monthly_repayment(
          principalAmount,
          interestAmount,
          feesAmount,
          OCR,
          bankReceiveDate,
          lastPayment,
        ),
      );
    },

    setLoanToDisputed: (loanId, reason) => {
      dispatch(loanActions.set_loan_to_disputed(loanId, reason));
    },

    setLoanToUndisputed: (loanId, reason) => {
      dispatch(loanActions.set_loan_to_undisputed(loanId, reason));
    },
    setInvoiceMethod: (loanGuid, method) => {
      dispatch(loanActions.set_invoice_method(loanGuid, method));
    },
    setPpiStatus: (loanGuid, isActive) => {
      dispatch(loanActions.set_ppi_subscription_status(loanGuid, isActive));
    },
  };
}

const loanConnector = connect(mapStateToProps, mapDispatchToProps);
export default loanConnector;
